import { nanoid } from '@reduxjs/toolkit';

const id = nanoid();

export default function ArrowDownRight({ color = '#000000', ...props }: Record<string, unknown> & { color?: string }) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>arrow-down-right</title>
      <defs>
        <path
          d="M0.292893219,0.292893219 C0.683417511,-0.0976310729 1.31658249,-0.0976310729 1.70710678,0.292893219 L12,10.585 L12,4 C12,3.48716416 12.3860402,3.06449284 12.8833789,3.00672773 L13,3 C13.5522847,3 14,3.44771525 14,4 L14,13 C14,13.0112225 13.9998151,13.0224019 13.9994483,13.0335352 C13.9988772,13.050591 13.997855,13.0679231 13.996384,13.0852242 C13.994564,13.1070574 13.9920941,13.1281144 13.9889807,13.1489612 C13.9863719,13.165949 13.9832978,13.1833753 13.9797599,13.2007258 C13.9753602,13.2227461 13.9701664,13.2444365 13.964279,13.2658396 C13.9599023,13.2814633 13.9552713,13.2968513 13.9502619,13.3121425 C13.9438775,13.3317977 13.9366843,13.3515792 13.928896,13.3710585 C13.9218036,13.3887956 13.914321,13.4060985 13.9063266,13.4232215 C13.8966234,13.4438914 13.8862061,13.4642939 13.8751242,13.484277 C13.8685012,13.4963944 13.8613931,13.5086131 13.8540045,13.5207088 C13.8382813,13.546275 13.8215099,13.5711307 13.8036865,13.5951593 C13.774687,13.6343256 13.7425008,13.6717127 13.7071068,13.7071068 L13.787214,13.6167501 C13.7374483,13.6801818 13.6801818,13.7374483 13.6167501,13.787214 C13.6098424,13.7927155 13.602603,13.7982466 13.5953066,13.8036654 C13.5711307,13.8215099 13.546275,13.8382813 13.5206602,13.8539326 C13.5086131,13.8613931 13.4963944,13.8685012 13.4840621,13.8753288 C13.4642939,13.8862061 13.4438914,13.8966234 13.4230991,13.9063462 C13.4060985,13.914321 13.3887956,13.9218036 13.371336,13.9287745 C13.3515792,13.9366843 13.3317977,13.9438775 13.3117364,13.9504533 C13.2968513,13.9552713 13.2814633,13.9599023 13.265993,13.9641549 C13.2444365,13.9701664 13.2227461,13.9753602 13.2007941,13.9798348 C13.1833753,13.9832978 13.165949,13.9863719 13.1484669,13.9889822 C13.1003621,13.9962388 13.0506203,14 13,14 L13.0852242,13.996384 C13.0679231,13.997855 13.050591,13.9988772 13.0332468,13.9994506 L13,14 L4,14 C3.44771525,14 3,13.5522847 3,13 C3,12.4477153 3.44771525,12 4,12 L10.585,12 L0.292893219,1.70710678 C-0.0675907428,1.34662282 -0.0953202783,0.779391764 0.209704612,0.387100557 Z"
          id={id}
        />
      </defs>
      <g id="🕹-Icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Feather" transform="translate(-97, -602)">
          <g id="arrow-down-right" transform="translate(102, 607)">
            <mask id={`mask-${id}`} fill="white">
              <use xlinkHref={`#${id}`} />
            </mask>
            <use id="Combined-Shape" fill={color} fillRule="nonzero" xlinkHref={`#${id}`} />
            <g id="🎨Color" mask={`url(#mask-${id})`} fill={color}>
              <g transform="translate(-5, -5)" id="Rectangle">
                <rect x={0} y={0} width={24} height={24} />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
